










import { Component, Vue } from 'vue-property-decorator';

import Modal from "./Base.vue";

@Component( {
	name: "ClaimSubmissionModal",
	components: {
		Modal
	}
} )
export default class ClaimSubmissionModal extends Vue {}
